import React from "react";
function FinancialYearReport({ onInputChange, namemain, defaultValuemain }) {
    return (

        <select
            className="form-control form-select"
            name={namemain}
            onChange={(e) => onInputChange(e.target.value)}>

            <option value="none" selected hidden disabled>{defaultValuemain === "" || defaultValuemain === null ? "Select" : defaultValuemain} </option>
            
            <option value="2023" id="2023"> 2023-2024</option>
            <option value="2024" id="2024"> 2024-2025</option>

        </select>




    );
};

export default FinancialYearReport;
